import TrailGrid from './TrailGrid';

export default TrailGrid;
